export default "__VITE_ASSET__BjdgEXJU__"